import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_WORKLOAD';

export async function getBillingPay(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getBillingPay - Start');

        const getBillingPay =
            await DashboardService.AdminService.getBillingPay(userData, params);

        LoggerService.logInfo('Action - getBillingPay - End - Success');

        return ResultModel.newSuccessResult(getBillingPay);
    }
    catch (error) {
        LoggerService.logInfo('Action - getBillingPay - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
